module.exports = __webpack_public_path__ + "img/Marquee-10.f4007961.jpg";